import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, pgTable, primaryKey, text, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { organization, team } from '../../../auth'
import { Challenge } from './challenge'

/**
 * Challenge to Team relationship table
 * Stores team runtimeIds for challenges that are not public
 */
export const ChallengeToTeam = pgTable(
  'challenge_to_team',
  {
    challengeId: uuid()
      .notNull()
      .references(() => Challenge.id, { onDelete: 'cascade' }),
    organizationId: text()
      .notNull()
      .references(() => organization.id, { onDelete: 'cascade' }),
    teamId: text()
      .notNull()
      .references(() => team.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({ columns: [table.challengeId, table.organizationId, table.teamId] }),
    index('challenge_to_team_challenge_idx').on(table.challengeId),
    index('challenge_to_team_organization_idx').on(table.organizationId),
    index('challenge_to_team_team_idx').on(table.teamId),
  ],
)

export const challengeToTeamRelations = relations(ChallengeToTeam, ({ one }) => ({
  challenge: one(Challenge, {
    fields: [ChallengeToTeam.challengeId],
    references: [Challenge.id],
  }),
  organization: one(organization, {
    fields: [ChallengeToTeam.organizationId],
    references: [organization.id],
  }),
  team: one(team, {
    fields: [ChallengeToTeam.teamId],
    references: [team.id],
  }),
}))

export const InsertChallengeToTeamSchema = createInsertSchema(ChallengeToTeam)
export const UpdateChallengeToTeamSchema = createUpdateSchema(ChallengeToTeam).partial()
export const SelectChallengeToTeamSchema = createSelectSchema(ChallengeToTeam)

export type InsertChallengeToTeam = typeof ChallengeToTeam.$inferInsert
export type UpdateChallengeToTeam = z.infer<typeof UpdateChallengeToTeamSchema>
export type SelectChallengeToTeam = typeof ChallengeToTeam.$inferSelect
